import React from 'react'
import styles from './about.module.scss'
import MyPicture from './img/mypicture.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays, faLanguage , faSchool , faStar, faEnvelope , faGraduationCap , faLocationDot , faEarthAmericas , faUserSecret , faLaptopCode , faPhoneVolume} from '@fortawesome/free-solid-svg-icons'
import classNames from 'classnames'
import SectionBorder from 'components/Section-Border'
import ZipButtonFile from 'components/Zip-File-Convertion'

export default function About() {

    

    return (
        <>
        <SectionBorder />
            <section className={styles.container} id="about">
                <div className={classNames(styles.divisionTitle, 'scroll_bottom')}>
                    <p className={styles.paragraphTitle}>Let me introduce myself</p>
                    <h2 className={styles.title}>About Me</h2>
                        <div className={styles.divisionDot} aria-label='Section-illustrators-dots'>
                                <span className={styles.dot}></span>
                                <span className={styles.dot}></span>
                                <span className={styles.dot}></span>
                                <span className={styles.dot}></span>
                        </div>
                </div>

                <div className={classNames(styles.imageDivision, 'scroll_scale')}>
                    <img className={styles.myPicture} src={MyPicture} alt="" />
                </div>

                <div className={classNames(styles.divisionIntroduction, 'scroll_scale' )}>
                    <h3 className={styles.titleIntroduce}>Hi there, I'm  <span style={{fontFamily: 'Berkshire Swash, cursive', fontWeight: '500'}}>Marcos Maio</span></h3>
                    <p className={styles.paragraphIntroduce}>
                        I'm a web application development student, specifically a front-end developer, I'm currently working on my own projects while studying to learn more and improve my skills.
                    </p>
                    <p className={styles.paragraphIntroduce}>
                        I'm currently studying for a degree in Systems Analysis and Development, and that's why I'm currently looking for a job in the area of ​​web development in a company that can give me confidence and help me to develop myself better as a professional.
                    </p>
                    <div className={styles.informationDivision}>
                        <p className={styles.info} > <FontAwesomeIcon icon={faCalendarDays} style={{color: "#4d4d4d",}} /> Date of birth: <span>07/26/2002</span></p>
                        <p className={classNames(styles.info, styles.smallerTopics)}> <FontAwesomeIcon icon={faLocationDot} style={{color: "#4d4d4d",}} /> Address: <span>Rio De Janeiro , Brasil</span></p>
                        <p className={styles.info} > <FontAwesomeIcon icon={faLanguage} style={{color: "#4d4d4d",}} /> Spoke Languages: <span>Brazilian Portuguese, American English</span></p>
                        <p className={classNames(styles.info, styles.smallerTopics)} > <FontAwesomeIcon icon={faEarthAmericas} style={{color: "#4d4d4d",}} /> Nationality: <span>Brazilian</span></p>
                        <p className={styles.info} > <FontAwesomeIcon icon={faSchool} style={{color: "#4d4d4d",}} /> Education: <span>Faculty Of Analysis And System Development</span></p>
                        <p className={classNames(styles.info, styles.smallerTopics)} > <FontAwesomeIcon icon={faUserSecret} style={{color: "#4d4d4d",}} /> Freelance: <span>Available</span></p>
                        <p className={styles.info} > <FontAwesomeIcon icon={faStar} style={{color: "#4d4d4d",}} /> Interests: <span>Web Development, Web Designer - UX UI</span></p>
                        <p className={classNames(styles.info, styles.smallerTopics)} > <FontAwesomeIcon icon={faLaptopCode} style={{color: "#4d4d4d",}} /> Experience: <span>Personal Projects</span></p>
                        <p className={styles.info} > <FontAwesomeIcon icon={faEnvelope} style={{color: "#4d4d4d",}} /> Email: <span>Marcospaulomaio2607@gmail.com</span></p>
                        <p className={classNames(styles.info, styles.smallerTopics)} > <FontAwesomeIcon icon={faPhoneVolume} style={{color: "#4d4d4d",}} /> Phone: <span>55+ 2196539-9177</span></p>
                        <p className={styles.info} > <FontAwesomeIcon icon={faGraduationCap} style={{color: "#4d4d4d",}} /> Certifications: <a href='/certificado-cursos.pdf' download><span>40 Completed Courses</span></a></p>
                    </div>

                    <div className={styles.container_button}>
                        <ZipButtonFile />
                    </div>
                </div>
            </section>
            <SectionBorder />
        </>
    )
}
